export default __webpack_public_path__ + "static/media/loading.24a00b2a.svg";